import { z } from 'zod'
import type {HttpClient} from "@jantm/model-core";
import {createAddressApi} from "@/api/wiser/address.ts";
import {defineModel} from '@jantm/model-core'
import AddressFullListItem from "@/templates/Wiser/AddressFullListItem.vue";
import AddressFullDetail from "@/templates/Wiser/AddressFullDetail.vue";
import {
  optionalBoolSchema,
  optionalDateTimeSchema,
  optionalNumberSchema,
  optionalStringSchema
} from "@/types/global.ts";
export const addressSchema = z.object({
  "id": z.int(),
  "title": optionalStringSchema,
  "adrestype": optionalStringSchema,
  "equalsrelatiekaart": optionalBoolSchema,
  "postcode": optionalStringSchema,
  "huisnummer": optionalStringSchema,
  "toevoeging": optionalStringSchema,
  "adres": optionalStringSchema,
  "plaats": optionalStringSchema,
  "land": optionalStringSchema,
  "contactpersoon": optionalStringSchema,
  "aanvullend": optionalStringSchema,
  "inverse-adresonderrelatie": optionalNumberSchema,
  "added_on": optionalDateTimeSchema,
  "changed_on": optionalDateTimeSchema
})

export type Address = z.infer<typeof addressSchema>

export const addressCollectionSchema = z.array(addressSchema)

export type AddressCollection = z.infer<typeof addressCollectionSchema>

export const addressFilterSchema = z.object({
  fields: z.array(addressSchema.keyof()).nullish().optional(),
  page: optionalStringSchema.default('1'),
  perPage: optionalStringSchema.default('25'),
  filters: optionalStringSchema,
})
export type AddressFilter = z.infer<typeof addressFilterSchema>

export type AddressFilters = {
  id?: string
  title?: string
  'inverse-adresonderrelatie'?: string
}

export interface CreateAddressModelOptions {
  client: HttpClient
  /** Override when this model does not live at `/api/addresss`. */
  endpoint?: string
}

export function createAddressModel(options: CreateAddressModelOptions) {
  return defineModel({
    name: 'Address',
    schema: addressSchema,
    collectionSchema: addressCollectionSchema,
    filterSchema: addressFilterSchema,
    api: createAddressApi(options.client, options.endpoint),
    identify: (address: Address) => String(address.id),
    templates: { FullListItem: AddressFullListItem, FullDetail: AddressFullDetail },
    // toItems: (collection) => Object.entries(collection.items).map(([, v]) => v),
    // toTotal: (collection => collection.metadata?.total)
  })
}

export type AddressModel = ReturnType<typeof createAddressModel>

declare module '@jantm/model-core' {
  interface ModelRegistry {
    Address: AddressModel
  }
}
